module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/map/map.component.html
// module id = ./src/app/components/map/map.component.html
// module chunks = main